import clsx from "clsx";
import React, { SetStateAction, useEffect, useRef } from "react";
import { FaChevronDown, FaPencilAlt, FaStamp } from "react-icons/fa";
import { MdTextFields } from "react-icons/md";

import useDropdown from "../../../hooks/useDropDown";
import { useAppSelector } from "../../../hooks";
import { selectUser } from "../../../states/slices/authReducer";

interface PdfToolBarProps {
  showdrawingbox: boolean;
  setShowdrawingbox: React.Dispatch<SetStateAction<boolean>>;
  numberPages: number;
  pageNumber: number;
  selectedStamp: string | null;
  setSelectedStamp: React.Dispatch<SetStateAction<string | null>>;

  drawImagetoPdf: (image: string) => void;
  handleAddText: () => void;
}
function PdfToolbar(props: PdfToolBarProps) {
  const {
    numberPages,
    pageNumber,
    setShowdrawingbox,
    showdrawingbox,
    setSelectedStamp,
    drawImagetoPdf,

    handleAddText,
  } = props;
  const { dropdownRef, dropdowns, setDropdowns, closeDropDown } = useDropdown();
  const user = useAppSelector(selectUser);

  const uploadInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.addEventListener("load", (event) => {
      const imageUrl = event.target?.result as string;
      drawImagetoPdf(imageUrl);
    });
    reader.readAsDataURL(file);
    closeDropDown("stampbox");
  };

  return (
    <div className="flex items-center gap-x-3 bg-white px-4 py-2 rounded-xl shadow-sm border border-gray-200">
      {/* Page Info */}
      <div className="border-r-2 flex items-center gap-x-2 pr-3">
        <span className="border border-gray-600 h-[30px] w-[30px] rounded-lg flex items-center justify-center text-sm font-semibold">
          {pageNumber}
        </span>
        <span className="text-gray-600">of</span>
        <span className="text-gray-600">{numberPages}</span>
      </div>

      {/* Tools */}
      <button
        className={clsx(
          "flex items-center text-sm gap-x-2 px-4 py-2 rounded-xl text-purple-700 hover:bg-purple-100 transition",
          showdrawingbox && "bg-purple-100",
        )}
        onClick={() => setShowdrawingbox(true)}
        type="button"
      >
        <FaPencilAlt className="text-purple-700" />
        Draw
      </button>
      {/* <button
        className='flex items-center text-sm gap-x-2 px-4 py-2 rounded-xl text-yellow-700 hover:bg-yellow-100 transition'
        type='button'
      >
        <MdHighlight className='text-yellow-700' />
        Highlight
      </button> */}
      <button
        className="flex items-center text-sm gap-x-2 px-4 py-2 rounded-xl text-blue-700 hover:bg-blue-100 transition"
        onClick={handleAddText}
        type="button"
      >
        <MdTextFields className="text-blue-700" />
        Add text
      </button>
      {/* <button
        className='flex items-center text-sm gap-x-2 px-4 py-2 rounded-xl text-green-700 hover:bg-green-100 transition'
        type='button'
      >
        <FaEdit className='text-green-700' />
        Edit text
      </button> */}

      {/* Sign Dropdown */}
      <div className="relative">
        <button
          className="flex items-center gap-x-2 relative text-sm text-red-700 px-4 py-2 rounded-xl hover:bg-red-100 transition cursor-pointer"
          onClick={() => setDropdowns({ ...dropdowns, stampbox: true })}
          type="button"
        >
          <FaStamp className="text-red-700" />
          Stamp
          <FaChevronDown className="mt-[2px]" size={8} />
        </button>
        {dropdowns.stampbox && (
          <div
            className="w-[22vw] max-w-sm h-[60vh] bg-white shadow-2xl rounded-xl fixed top-20 z-50 flex flex-col p-4"
            ref={dropdownRef.stampbox}
          >
            <h2 className="text-lg font-semibold text-gray-800 mb-4 text-center">
              Select Stamp
            </h2>

            <div className="flex flex-col gap-4 overflow-y-auto pr-1 flex-1">
              <div
                className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 transition cursor-pointer"
                onClick={() => {
                  if (user?.stamp_photo) {
                    drawImagetoPdf(user.stamp_photo);
                  }
                  setTimeout(() => {
                    closeDropDown("stampbox");
                  }, 500);
                }}
              >
                <img
                  alt={`Signature`}
                  className="w-12 h-12 rounded-md object-contain border border-gray-200"
                  crossOrigin="anonymous"
                  src={user?.stamp_photo}
                />
              </div>
            </div>

            {/* Upload Button */}
            <div className="mt-4">
              <label
                className="w-full cursor-pointer bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2 px-4 rounded-lg text-center block"
                onClick={() => uploadInputRef?.current?.click()}
              >
                Upload New Stamp
              </label>
              <input
                accept="image/*"
                className="hidden"
                onChange={handleFileChange}
                ref={uploadInputRef}
                type="file"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PdfToolbar;
